import { privateApi } from 'services';
import { RecentlyViewedJobGroup } from './types';

const fetchRecentlyViewedJobGroups = async (
    userId: string,
    businessAccountId: string,
): Promise<RecentlyViewedJobGroup[]> =>
    privateApi.get<RecentlyViewedJobGroup[]>(
        `users/${userId}/recently-visited/business-accounts/${businessAccountId}/job-groups`,
    );

const postRecentlyViewedJobGroup = async (userId: string, jobGroupId: string): Promise<RecentlyViewedJobGroup> =>
    privateApi.post<RecentlyViewedJobGroup>(`users/${userId}/recently-visited/job-groups/${jobGroupId}`);

export const RecentlyViewedJobGroupGateway = {
    fetchRecentlyViewedJobGroups,
    postRecentlyViewedJobGroup,
};
